<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container w-min-600">
          <div class="modal-header">
            <slot name="header">
              New Plant
            </slot>
          </div>
          <div class="modal-body">
            <slot name="body">
              <div class="row">
                <div class="col-2">
                  <label for="name">Name:</label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    class="form-control"
                    id="name"
                    ref="plant_name"
                    name="name"
                    autocomplete="plantname"
                    placeholder="name"
                    v-model="name"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-2">
                  <label for="description">Description:</label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    class="form-control"
                    id="description"
                    ref="plant_description"
                    name="description"
                    placeholder="description"
                    autocomplete="name"
                    v-model="description"
                  />
                </div>
              </div>
            </slot>
          </div>
          <div class="modal-footer">
            <slot name="footer">
              <button class="btn btn-plt" @click="_save">
                Save &amp; Close
              </button>
              <button class="btn btn-plt" @click="$emit('close')">
                Cancel
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "NewPlantModal",
  props: {
    site_id: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    name: "",
    description: "",
  }),
  methods: {
    ...mapActions("plants", ["apiCreatePlant"]),
    _save() {
      if (!this.$refs.plant_name.value) {
        alert("please enter a name");
        return;
      }
      var plant = {
        id: 0,
        name: this.$refs.plant_name.value,
        description: this.$refs.plant_description.value,
        site_id: this.site_id,
        active: true,
      };
      this.apiCreatePlant(plant);
      this.$emit("close");
    },
    clear() {
      this.name = "";
      this.description = "";
    },
  },
  components: {},
};
</script>
